<template>
  <w-sliding-popup ref="jsErrorPopup" width="800px" :title="title" @close="onClosePopup">
    <div slot="content">
      <span class="title-bar title-h4">자바스크립트 에러 정보</span>
      <div class="list form-list mr-b20">
        <el-form :model="jsErrorData" label-width="150px" label-position="left">
          <el-form-item label="메시지">{{ getValueAfterCheckEmpty(jsErrorData.messageText) }}</el-form-item>
          <el-form-item label="파일">{{ getValueAfterCheckEmpty(jsErrorData.fileText) }}</el-form-item>
          <el-form-item label="유저 에이전트">{{ getValueAfterCheckEmpty(jsErrorData.userAgentText) }}</el-form-item>
          <el-form-item label="에러 (건)">{{ converNumberFormat(jsErrorData.count) }}</el-form-item>
          <el-form-item label="행">{{ getValueAfterCheckEmpty(jsErrorData.lineNumber) }}</el-form-item>
          <el-form-item label="열">{{ getValueAfterCheckEmpty(jsErrorData.columnNumber) }}</el-form-item>
        </el-form>
      </div>
      <div class="title-bar title-h4">스택 트레이스</div>
      <el-input readonly type="textarea" v-model="jsErrorData.stacktraceText" :autosize="{ minRows: 24 }"></el-input>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isEmpty } from '@/utils/basic';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { convertThousandSeparatorFormat } from '@/utils/number';
import ApmCountAPI from '@/api/performance/apm/count-info';

export default {
  name: 'WJsErrorDetailPopup',
  props: {
    uri: String,
  },
  data() {
    return {
      jsErrorData: {},
      params: null,
    };
  },
  computed: {
    title() {
      const uri = this.uri;
      if (!isEmpty(uri)) {
        return `${uri} 상세정보`;
      }
      return '스크립트 에러 상세정보';
    },
  },
  methods: {
    getValueAfterCheckEmpty,
    /**
     * 스크립트 에러 상세정보 팝업을 띄운다.
     * @return {[type]} [description]
     * @author jda
     */
    open(params) {
      this.$refs.jsErrorPopup.visible = true;
      this.params = params;
      this.loadData();
    },
    /**
     * 스크립트 에러 상세 리스트를 조회한다.
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      if (isEmpty(this.params)) {
        return;
      }
      ApmCountAPI.getEumJsErrorRaw(this.params).then((response) => {
        if (response.data.success) {
          this.jsErrorData = response.data.data;
        } else {
          this.jsErrorData = {};
        }
      });
    },

    /**
     * 슬라이딩 팝업을 닫는다.
     * @return {[type]} [description]
     * @author jda
     */
    onClosePopup() {
      this.params = null;
      this.showSearchTool = false;
      this.stacktrace = null;
      this.jsErrorData = {};
      this.$refs.jsErrorPopup.visible = false;
    },
    /**
     * 숫제 포맷
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     * @author jda
     */
    converNumberFormat(value) {
      if (isEmpty(value)) {
        return EMPTY_TEXT;
      }
      return convertThousandSeparatorFormat(value);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/apm/components/popup/JsErrorDetailPopup.vue